import { Navigate, Route, Routes } from "react-router-dom";
import { Register } from "./pages/Register";
import { Login } from "./pages/Login";
import { Layout } from "antd";
import { ResetPassword } from "./pages/ResetPassword";

export default function Auth() {
  return (
    <Layout>
      <Routes>
        <Route index element={<Navigate to="dang-nhap" />} />
        <Route path="dang-nhap" element={<Login />} />
        <Route path="dang-ky" element={<Register />} />
        <Route path="dat-lai-mat-khau" element={<ResetPassword />} />
      </Routes>
    </Layout>
  );
}
